export default {"src":"/_next/static/media/EOG.e282d8dc.svg","height":18,"width":18};